import React from 'react';

import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';

function TermsAndConditions(props) {
    const {
        className,
        linkText,
        href,
    } = props;

    return (
        <A
            className={className}
            href={href}
            target="_blank"
        >
            {linkText}
        </A>
    );
}

TermsAndConditions.propTypes = {
    className: PropTypes.string,
    linkText: PropTypes.string,
    href: PropTypes.string,
};
TermsAndConditions.defaultProps = {
    className: '',
    linkText: '',
    href: '/terms-and-conditions',
};

export default TermsAndConditions;
